// extracted by mini-css-extract-plugin
export default {"container":"Error_container__3Wejh","wrapper":"Error_wrapper__d0lzg"};